<template>
  <div>
    <div class="top-breadcrumb">
      <ol class="breadcrumb" style="background-color: white">
        <li class="breadcrumb-item" style="margin-left: 15px">
          <router-link to="" style="color: #8cc63f !important">
            Portfolio Management
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link
            style="color: #8cc63f !important"
            :to="'/' + authUser.userable_type + '/projects'"
            >Projects</router-link
          >
        </li>
      </ol>
    </div>
    <div
      style="display: flex; justify-content: center; margin-top: 60px"
      class="col-12"
    >
      <span
        class="col-1"
        style="
          display: flex;
          align-items: center;
          justify-content: center;
          color: gray;
        "
      >
        <i
          class="fa fa-filter"
          style="font-size: 15px; color: #8cc63f; margin-right: 5px"
        ></i>
        Filter
      </span>
      <span class="col-3">
        <input
          @change="filter()"
          v-model="keyword"
          type="text"
          class="form-control"
          placeholder="Keyword"
          style="padding: 10px"
        />
      </span>
      <span class="col-4">
        <multiselect
          v-model="selected_countries"
          :options="countries"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Select Countries"
          label="name"
          :show-labels="false"
          track-by="id"
          @close="filter()"
        >
          <template slot="selection" slot-scope="{ values, isOpen }"
            ><span
              class="multiselect__single"
              v-if="values.length &amp;&amp; !isOpen"
              >{{ values.length }} countries selected</span
            ></template
          >
        </multiselect>
      </span>
      <span class="col-4">
        <multiselect
          v-model="selected_clusters"
          :options="clusters"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Select Clusters"
          :custom-label="customClusterLabel"
          label="name"
          :show-labels="false"
          track-by="id"
          @close="filter()"
        >
          <template slot="selection" slot-scope="{ values, isOpen }"
            ><span
              class="multiselect__single"
              v-if="values.length &amp;&amp; !isOpen"
              >{{ values.length }} clusters selected</span
            ></template
          >
        </multiselect>
      </span>
    </div>
    <div style="display: flex; margin-top: 10px" class="col-12">
      <span class="col-4">
        <multiselect
          v-model="selected_assets"
          :options="assets"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Select Assets"
          :custom-label="customAssetLabel"
          :show-labels="false"
          track-by="id"
          @close="filter()"
        >
          <template slot="selection" slot-scope="{ values, isOpen }"
            ><span
              class="multiselect__single"
              v-if="values.length &amp;&amp; !isOpen"
              >{{ values.length }} assets selected</span
            ></template
          >
        </multiselect>
      </span>
      <span class="col-4">
        <multiselect
          v-model="selected_regions"
          :options="regions"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Select Regions"
          :custom-label="customRegionLabel"
          :show-labels="false"
          track-by="id"
          @close="filter()"
        >
          <template slot="selection" slot-scope="{ values, isOpen }"
            ><span
              class="multiselect__single"
              v-if="values.length &amp;&amp; !isOpen"
              >{{ values.length }} regions selected</span
            ></template
          >
        </multiselect>
      </span>
      <span class="col-4">
        <multiselect
          v-model="selected_status"
          :options="statusList"
          :multiple="true"
          :close-on-select="false"
          :clear-on-select="false"
          :preserve-search="true"
          placeholder="Select Status"
          label="name"
          :show-labels="false"
          track-by="id"
          @close="filter()"
        >
          <template slot="selection" slot-scope="{ values, isOpen }"
            ><span
              class="multiselect__single"
              v-if="values.length &amp;&amp; !isOpen"
              >{{ values.length }} status selected</span
            ></template
          >
        </multiselect>
      </span>
    </div>
    <div style="display: flex; justify-content: center; margin-top: 50px">
      <div
        style="display: flex; justify-content: center; cursor: pointer"
        @click="redirectToCreateProject()"
      >
        <div>
          <i
            class="fa fa-plus-circle"
            style="font-size: 90px; color: #8cc63f; margin-right: 5px"
          ></i>
        </div>
        <div
          style="
            display: flex;
            align-items: center;
            flex-direction: column;
            margin: 0;
            justify-content: center;
            margin-left: 10px;
          "
        >
          <p
            style="
              margin: 0px;
              font-size: 40px;
              margin-bottom: 5px;
              color: #8cc63f;
            "
          >
            ADD
          </p>
          <p style="margin: 0; color: #8cc63f; font-size: 14px">new project</p>
        </div>
      </div>
    </div>
    <div style="display: flex; justify-content: center; margin-top: 50px">
      <md-card
        class="md-card-stats"
        style="
          background-color: white;
          max-width: 90%;
          border-radius: 15px;
          padding: 40px;
        "
      >
        <spinner v-if="searchingProjects" />

        <table style="text-align: center" v-else>
          <thead>
            <tr>
              <th>Project ID</th>
              <th>Project Name</th>
              <th>Cluster</th>
              <th>Region</th>
              <th>Country</th>
              <th>
                Book Value (native)
                <i
                  style="cursor: pointer"
                  @click="toggleShowInvestmentValues()"
                  :class="
                    showInvestmentValues ? 'fa fa-eye' : 'fa fa-eye-slash'
                  "
                ></i>
              </th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(project, key) in projects" :key="key">
              <td>
                <router-link
                  style="color: black !important; font-weight: bold;"
                  :to="
                    '/' +
                    authUser.userable_type +
                    '/project/' +
                    project.code +
                    '/' +
                    project.id
                  "
                >
                  {{ project.code }}</router-link
                >
              </td>
              <td>{{ project.name }}</td>
              <td>{{ project.cluster_name }}</td>
              <td>{{ project.region_code }}</td>
              <td>{{ project.country_name }}</td>
              <td v-if="showInvestmentValues">
                
                {{ fixNumberView(project.project_financials.principal_native) }}
                {{ project.project_financials.currency_code }}
              </td>
              <td v-else>******</td>
              <td>
                {{
                  statusList.find((status) => {
                    return status.id == project.status;
                  }).name
                }}
              </td>
              <!-- <td>
                <i
                  style="cursor: pointer"
                  @click="redirectToProject(project)"
                  class="fa fa-eye"
                ></i>
              </td> -->
            </tr>
          </tbody>
        </table>
      </md-card>
    </div>
  </div>
</template><script>
import ProjectModal from "./components/modals/projectModal.vue";
import ProjectsFilter from "../../filters/ProjectsFilter";
import CountriesFilter from "../../filters/CountriesFilter";
import sweetAlert from "sweetalert2";
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";
import Multiselect from "vue-multiselect";

export default {
  name: "projects",
  data() {
    return {
      selected_countries: null,
      selected_clusters: null,
      selected_assets: null,
      selected_regions: null,
      selected_status: null,
      selectedProjectId: null,
      actionModalType: null,
      showProjectModal: false,
      country_id: null,
      keyword: null,
      showInvestmentValues: false,
      statusList: [
        { id: "active", name: "Active" },
        { id: "inactive", name: "InActive" },
        { id: "notstarted", name: "Not Started" },
        { id: "closed", name: "Closed" },
      ],
    };
  },
  components: {
    ProjectModal,
    Multiselect,
    Spinner,
  },
  created: function () {
    this.$store.dispatch("searchAssets");
    this.$store.dispatch("searchRegions");
    this.$store.dispatch("searchClusters");
    var projectsFilter = ProjectsFilter();
    projectsFilter.with = ["projectFinancials", "projectRating", "asset"];
    this.$store
      .dispatch("searchProjects", {
        filter: projectsFilter,
        resultMode: "default",
      })
      .then(() => {
        var countriesFilter = CountriesFilter();
        this.projects.forEach((project) => {
          countriesFilter.ids.push(project.country_id);
        });
        this.$store.dispatch("searchCountries", {
          filter: countriesFilter,
          resultMode: "default",
        });
      });
  },
  computed: {
    activeProject() {
      // can be not array when paginated
      if (this.projects && Array.isArray(this.projects)) {
        return this.projects.find((c) => c.id == this.selectedProjectId);
      }
    },
    ...mapState({
      authUser: (state) => state.userStore.authUser,
      regions: (state) => state.regionStore.regionSearch.regions,
      assets: (state) => state.assetStore.assetSearch.assets,
      clusters: (state) => state.clusterStore.clusterSearch.clusters,
      countries: (state) => state.countryStore.countrySearch.countries,
      projects: (state) => state.projectStore.projectSearch.projects,
      createProjectStatus: (state) =>
        state.projectStore.projectCreate.createProjectStatus,
      updateProjectStatus: (state) =>
        state.projectStore.projectUpdate.updateProjectStatus,
      deleteProjectStatus: (state) =>
        state.projectStore.projectDelete.deleteProjectStatus,
      searchingProjects: (state) =>
        state.projectStore.projectSearch.searchingProjects,
    }),
  },
  methods: {
    customRegionLabel(region) {
      return region.code + "(" + region.name + ")";
    },
    customAssetLabel(asset) {
      return asset.code + "(" + asset.name + ")";
    },
    customClusterLabel(cluster) {
      return cluster.code + "(" + cluster.name + ")";
    },
    init() {
      this.selectedProjectId = null;
      this.actionModalType = null;
      this.showProjectModal = false;
      this.$store.dispatch("searchProject");
    },
    redirectToProject(project) {
      this.$router.push(
        "/" +
          this.authUser.userable_type +
          "/project/" +
          project.code +
          "/" +
          project.id
      );
    },
    fixNumberView(value) {
      const numFor = Intl.NumberFormat("en-US", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 4,
      });
      return value < 0
        ? "(" + Math.abs(value).toLocaleString() + ")"
        : numFor.format(value);
    },
    toggleShowInvestmentValues() {
      this.showInvestmentValues = !this.showInvestmentValues;
    },
    filter() {
      var projectsFilter = ProjectsFilter();
      projectsFilter.text = this.keyword;
      if (this.selected_countries) {
        this.selected_countries.forEach((country) => {
          projectsFilter.country_ids.push(country.id);
        });
      }
      if (this.selected_clusters) {
        this.selected_clusters.forEach((cluster) => {
          projectsFilter.asset_ids = projectsFilter.asset_ids.concat(
            cluster.asset_ids
          );
        });
      }
      if (this.selected_assets) {
        this.selected_assets.forEach((asset) => {
          if (!projectsFilter.asset_ids.includes(asset.id)) {
            projectsFilter.asset_ids.push(asset.id);
          }
        });
      }
      if (this.selected_regions) {
        this.selected_regions.forEach((region) => {
          projectsFilter.region_ids.push(region.id);
        });
      }
      if (this.selected_status) {
        this.selected_status.forEach((status) => {
          projectsFilter.status.push(status.id);
        });
      }
      projectsFilter.with = ["projectFinancials", "projectRating", "asset"];
      this.$store.dispatch("searchProjects", {
        filter: projectsFilter,
        resultMode: "default",
      });
    },
    handleSave(project) {
      if (this.actionModalType == "createModal") {
        this.createProject(project);
      } else {
        this.updateProject(project);
      }
    },
    redirectToCreateProject() {
      this.$router.push("/" + this.authUser.userable_type + "/projects/create");
    },
    createProject(project) {
      this.$store.dispatch("createProject", project);
    },
    updateProject(project) {
      this.$store.dispatch("updateProject", project);
    },
    deleteProject(id) {
      sweetAlert({
        title: "Confirmation",
        text: "Are you sure you want to delete this project?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.value) {
          this.$store.dispatch("deleteProject", id);
        }
      });
    },
    toggleCreateProjectModal() {
      this.showProjectModal = !this.showProjectModal;
      this.showProjectModal ? (this.actionModalType = "createModal") : null;
    },
    toggleUpdateProjectModal(id = null) {
      this.showProjectModal = !this.showProjectModal;
      if (this.showProjectModal) {
        this.actionModalType = "updateModal";
        this.selectedProjectId = id;
      } else {
        this.actionModalType = null;
        this.selectedProjectId = null;
      }
    },
  },
  watch: {
    createProjectStatus() {
      if (this.createProjectStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Project has been created successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.createProjectStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Project creation has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
    updateProjectStatus() {
      if (this.updateProjectStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Project has been updated successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.updateProjectStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Project update has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
    deleteProjectStatus() {
      if (this.deleteProjectStatus == "success") {
        sweetAlert({
          title: "Success",
          text: "Project has been deleted successfully",
          icon: "success",
          confirmButtonText: "Done",
        }).then(() => {
          this.init();
        });
      } else if (this.deleteProjectStatus == "failed") {
        sweetAlert({
          title: "Failed",
          text: "Project delete has failed",
          IntersectionObserver: "error",
          confirmButtonText: "Return",
        });
      }
    },
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
 <style>
.multiselect__placeholder {
  color: #495057;
}
.multiselect__option--highlight,
.multiselect__option--highlight:after {
  background: #00a5e3;
}
.multiselect__tags {
  background-color: #fafaf7;
  height: calc(1.5em + 0.75rem + 2px);
  padding: 5px 40px 0 8px;
  font-size: 16px;
}
.md-ripple {
  padding: 0px !important;
}
.table.vgt-table {
  font-size: 20px;
}
.form-control {
  border: 1px solid #ced4da !important;
  background-image: none;
  border-radius: 5px !important;
}
.custom-select {
  background-color: #fafaf7;
}
</style>>



// WEBPACK FOOTER //
// resources/js/pages/admin/projects.vue